module.exports = __webpack_public_path__ + "img/notice_icon1.a4883d92.svg";